export default __webpack_public_path__ + "static/media/applestore.213ab3a4.jpg";